module.exports = __webpack_public_path__ + "img/United_Kingdom.8afabec0.png";